import React, { createContext, useContext, useState } from "react";

const BLUE_STRIP_STORAGE_KEY = "blueStripHidden";
const BLUE_STRIP_TIMESTAMP_KEY = "blueStripHiddenTimestamp";

interface BlueStripContextType {
  isHidden: boolean;
  setHidden: (hidden: boolean) => void;
  clearHidden: () => void;
}

const BlueStripContext = createContext<BlueStripContextType | undefined>(undefined);

// Check if the hidden state has expired (new month has started)
const isHiddenExpired = (timestamp: string): boolean => {
  const hiddenDate = new Date(timestamp);
  const currentDate = new Date();

  // Check if we're in a different month and year
  return (
    hiddenDate.getMonth() !== currentDate.getMonth() || hiddenDate.getFullYear() !== currentDate.getFullYear()
  );
};

export const BlueStripProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isHidden, setIsHidden] = useState(true);

  // useEffect(() => {
  //   const hidden = localStorage.getItem(BLUE_STRIP_STORAGE_KEY);
  //   const timestamp = localStorage.getItem(BLUE_STRIP_TIMESTAMP_KEY);

  //   if (hidden === "true" && timestamp) {
  //     // Check if the hidden state has expired
  //     if (isHiddenExpired(timestamp)) {
  //       // Clear expired hidden state
  //       localStorage.removeItem(BLUE_STRIP_STORAGE_KEY);
  //       localStorage.removeItem(BLUE_STRIP_TIMESTAMP_KEY);
  //       setIsHidden(false);
  //     } else {
  //       setIsHidden(true);
  //     }
  //   } else {
  //     setIsHidden(false);
  //   }
  // }, []);

  const setHidden = (hidden: boolean) => {
    if (typeof window === "undefined") return;

    if (hidden) {
      // Store current timestamp when hiding
      localStorage.setItem(BLUE_STRIP_STORAGE_KEY, hidden.toString());
      localStorage.setItem(BLUE_STRIP_TIMESTAMP_KEY, new Date().toISOString());
    } else {
      // Clear both values when showing
      localStorage.removeItem(BLUE_STRIP_STORAGE_KEY);
      localStorage.removeItem(BLUE_STRIP_TIMESTAMP_KEY);
    }

    setIsHidden(hidden);
  };

  const clearHidden = () => {
    if (typeof window === "undefined") return;
    localStorage.removeItem(BLUE_STRIP_STORAGE_KEY);
    localStorage.removeItem(BLUE_STRIP_TIMESTAMP_KEY);
    setIsHidden(false);
  };

  return (
    <BlueStripContext.Provider value={{ isHidden, setHidden, clearHidden }}>
      {children}
    </BlueStripContext.Provider>
  );
};

export const useBlueStrip = () => {
  const context = useContext(BlueStripContext);
  if (context === undefined) {
    throw new Error("useBlueStrip must be used within a BlueStripProvider");
  }
  return context;
};
